
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M64 32.8c1.1 0 2.2.4 3 1.3l59.7 59.7c1.7 1.7 1.7 4.4 0 6.1s-4.4 1.7-6.1 0L64 43.2 7.3 99.9c-1.7 1.7-4.4 1.7-6.1 0-1.7-1.7-1.7-4.4 0-6.1L61 34.1c.8-.8 1.9-1.3 3-1.3z"}})])
          )
        }
      }
    